import { render, staticRenderFns } from "./mapbox.vue?vue&type=template&id=2a8a97e5&scoped=true"
import script from "./mapbox.vue?vue&type=script&lang=js"
export * from "./mapbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a97e5",
  null
  
)

export default component.exports